/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
export function moveKeyToTheEnd(key: string, inputArray: string[]): string[] {
  const newArray: string[] = []

  let keyFound = false
  inputArray.forEach((el) => {
    if (!keyFound && el === key) {
      keyFound = true
    } else {
      newArray.push(el)
    }
  })

  if (keyFound) {
    newArray.push(key)
  }

  return newArray
}
